import type { Question, SurveyAnswers } from "./types";

/**
 * Compiles a unique set of tags from the viewer's intake question responses.
 */
export function compileSelectedTags(
  answers: SurveyAnswers = {},
  questions: Question[] = [],
): Set<string> {
  const selectedTags = new Set<string>();
  const questionMap = new Map(questions.map((q) => [q.id, q]));

  for (const [qId, raw] of Object.entries(answers)) {
    const q = questionMap.get(qId);
    if (!q || q.answerType === "short_text") continue;

    const pickedIds = Array.isArray(raw) ? raw : raw ? [raw] : [];
    const optionMap = new Map(q.options.map((o) => [o.id, o]));

    for (const optId of pickedIds) {
      const opt = optionMap.get(optId);
      if (opt && Array.isArray(opt.attached_tags)) {
        for (const tag of opt.attached_tags) {
          const trimmed = typeof tag === "string" ? tag.trim() : "";
          if (trimmed) selectedTags.add(trimmed);
        }
      }
    }
  }

  return selectedTags;
}

/**
 * Every tag in use, for autocomplete: the ones survey answers give viewers and the ones paths route on.
 */
export function collectAllTags(
  questions: Array<{ options: Array<{ attached_tags?: string[] }> }> = [],
  paths: Array<{ tags?: string[] }> = [],
): string[] {
  const set = new Set<string>();
  const add = (tags: string[] | undefined) => {
    for (const t of Array.isArray(tags) ? tags : []) {
      const trimmed = typeof t === "string" ? t.trim() : "";
      if (trimmed) set.add(trimmed);
    }
  };
  for (const q of questions) for (const opt of q.options) add(opt.attached_tags);
  for (const p of paths) add(p.tags);
  return [...set].sort((a, b) => a.localeCompare(b));
}
